import { ColumnsType } from "antd/es/table";
import { useCallback, useMemo } from "react";
import { IIncidentReport } from "../../../../../../types/IncidentReports";
import dayjs from "../../../../../../configs/dayjs";
import { DATE_FORMAT } from "../../../../../../lib/constants";
import { DeleteOutlined } from "@ant-design/icons";
import { useDefaultDeleteModal } from "../../../../../../lib/hooks/defaultDeleteModal";
import { deleteIncident } from "../../../../../../acions/incidentReports";
import { usePermissions } from "../../../../../../lib/hooks/usePermissions";

export const useTableColumns = (type: 1 | 2, reloadData: () => void) => {
  const { openDeleteModal } = useDefaultDeleteModal(deleteIncident, reloadData);

  const { hasAccessByController } = usePermissions("IncidentReports");

  const onDeleteBtnClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>): void => {
      e.stopPropagation();
      openDeleteModal(e.currentTarget.id, "Delete Incident Report");
    },
    [openDeleteModal],
  );

  const columns: ColumnsType<IIncidentReport> = useMemo(() => {
    const values: ColumnsType<IIncidentReport> = [
      {
        title: "Date",
        dataIndex: "date",
        width: "9%",
        render: (value: string) => dayjs(value).format(DATE_FORMAT),
      },
      {
        title: "Description",
        dataIndex: "description",
        width: "60%",
      },
      {
        title: type === 2 ? "Account #" : "Customer",
        dataIndex: type === 2 ? "contractNumber" : "customerName",
        width: "10%",
        ellipsis: true,
      },
      {
        title: "Reporter",
        dataIndex: "reporterName",
        width: hasAccessByController("Delete") ? "16%" : "21%",
        ellipsis: true,
      },
    ];

    hasAccessByController("Delete") &&
      values.push({
        title: "",
        dataIndex: "action",
        width: "5%",
        align: "right",
        render: (_: unknown, record: IIncidentReport) => (
          <DeleteOutlined
            id={record.id}
            className="text title logo-cursor"
            onClick={onDeleteBtnClick}
          />
        ),
      });

    return values;
  }, [type, hasAccessByController, onDeleteBtnClick]);

  return { columns };
};
